const SYSTEM_FONTS = [
  "Helvetica",
  "Arial",
  "Georgia",
  "Times New Roman",
  "Courier New",
];

const safeFamilyName = (family) => String(family || "").replace(/[^a-zA-Z0-9]+/g, "");

export const FONT_CATEGORIES = [
  {
    label: "Modern Sans",
    fonts: [
      "Inter",
      "Roboto",
      "Poppins",
      "Montserrat",
      "Manrope",
      "Sora",
      "Space Grotesk",
      "DM Sans",
      "Plus Jakarta Sans",
      "Outfit",
      "Lexend",
      "Work Sans",
      "Nunito",
      "Nunito Sans",
      "Rubik",
      "Urbanist",
      "Figtree",
      "Onest",
      "Epilogue",
      "Albert Sans",
      "Be Vietnam Pro",
      "Red Hat Display",
      "Hanken Grotesk",
      "Instrument Sans",
      "Archivo",
      "Barlow",
      "Kanit",
      "Hind",
      "Noto Sans Devanagari",
    ],
  },
  {
    label: "Bold Display",
    fonts: [
      "Oswald",
      "Anton",
      "Bebas Neue",
      "Teko",
      "Archivo Black",
      "Alfa Slab One",
      "Righteous",
      "Abril Fatface",
      "Passion One",
      "Fjalla One",
      "Staatliches",
      "Titan One",
    ],
  },
  {
    label: "Elegant Serif",
    fonts: [
      "Playfair Display",
      "Merriweather",
      "Lora",
      "PT Serif",
      "Cormorant Garamond",
      "EB Garamond",
      "Libre Baskerville",
      "Source Serif 4",
      "Crimson Text",
      "Bitter",
      "Spectral",
      "DM Serif Display",
      "DM Serif Text",
      "Fraunces",
      "Noto Serif",
      "Roboto Slab",
      "Zilla Slab",
      "Cardo",
      "Marcellus",
      "Cinzel",
      "Prata",
      "Bodoni Moda",
      "Italiana",
      "Cormorant",
    ],
  },
  {
    label: "Script & Signature",
    fonts: [
      "Berkshire Swash",
      "Great Vibes",
      "Dancing Script",
      "Pacifico",
      "Caveat",
      "Sacramento",
      "Allura",
      "Parisienne",
      "Tangerine",
      "Pinyon Script",
      "Yellowtail",
      "Satisfy",
      "Kaushan Script",
      "Alex Brush",
      "Cookie",
      "Shadows Into Light",
      "Homemade Apple",
      "Marck Script",
      "Petit Formal Script",
    ],
  },
  {
    label: "Monospace",
    fonts: [
      "Roboto Mono",
      "JetBrains Mono",
      "Space Mono",
      "IBM Plex Mono",
      "Fira Code",
      "Source Code Pro",
      "Inconsolata",
    ],
  },
  {
    label: "System",
    fonts: SYSTEM_FONTS,
  },
];

export const FONT_OPTIONS = FONT_CATEGORIES.flatMap((c) => c.fonts);

export const LOCAL_FONT_FACES = FONT_OPTIONS.flatMap((family) => {
  const prefix = safeFamilyName(family);
  return [
    { family, weight: 400, file: `${prefix}-Regular.ttf` },
    { family, weight: 700, file: `${prefix}-Bold.ttf` },
  ];
});

export const LOCAL_FONT_FAMILIES = [
  ...new Set(LOCAL_FONT_FACES.map((font) => font.family)),
];

export const FONT_CATEGORY_BY_FONT = FONT_CATEGORIES.reduce((acc, c) => {
  c.fonts.forEach((f) => {
    acc[f] = c.label;
  });
  return acc;
}, {});

export const GOOGLE_FONT_FAMILIES = FONT_OPTIONS.filter(
  (f) => !SYSTEM_FONTS.includes(f),
);

export const WEIGHT_OPTIONS = [
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
];
